import { render, staticRenderFns } from "./VehicleView.vue?vue&type=template&id=150fd62a"
import script from "./VehicleView.vue?vue&type=script&lang=js"
export * from "./VehicleView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports